import '../../../../vendor/angular-clipboard/angular-clipboard';

export const clipboardComponentModule = 'angular-clipboard';
